import { ref } from 'vue'

export default function (handler) {
  function clickOutside (event) {
    const path = event.path || (event.composedPath && event.composedPath())
    const outsideCheck = path ? path.indexOf(el.value) < 0 : !el.value.contains(event.target)
  
    const isClickOutside = event.target !== el.value && outsideCheck

    if (isClickOutside) {
      handler()
    }
  } 

  function bindClickOutside () {
    window.addEventListener('click', clickOutside, false)
  }

  function unbindClickOutside () {
    window.removeEventListener('click', clickOutside, false)
  }

  const el = ref(null)

  return { el, bindClickOutside, unbindClickOutside }
}